import { Checkbox, Divider, Menu, Typography } from "antd";
import React from "react";
import {
  findAllJobPostDto,
  PositionWithOpeningCount,
} from "../../../Interface/Index";

interface JobPositionFilterMenuProps {
  setFilters: React.Dispatch<React.SetStateAction<findAllJobPostDto>>;
  filters: findAllJobPostDto;
  positionsWithOpeningCount: PositionWithOpeningCount[];
}
const JobPositionFilterMenu: React.FC<JobPositionFilterMenuProps> = ({
  filters,
  positionsWithOpeningCount,
  setFilters,
}) => {
  const onCheckboxChange =
    (position: string) => (e: { target: { checked: boolean } }) => {
      const isSelected = e.target.checked;
      const newFilters = { ...filters };

      if (isSelected) {
        newFilters.position = [...newFilters.position, position];
      } else {
        newFilters.position = newFilters.position.filter(
          (value) => value !== position
        );
      }

      setFilters(newFilters);
    };

  const onPositionClick = (position: string) => {
    const newFilters = { ...filters };

    if (newFilters.position.includes(position)) {
      newFilters.position = newFilters.position.filter(
        (value) => value !== position
      );
    } else {
      newFilters.position = [...newFilters.position, position];
    }

    setFilters(newFilters);
  };

  const items = positionsWithOpeningCount.map(
    (position: PositionWithOpeningCount, index: number) => ({
      key: position.position,
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 8,
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          <Checkbox
            onChange={onCheckboxChange(position.position)}
            checked={filters.position.includes(position.position)}
            onClick={(e) => e.stopPropagation()}
            id={`checkbox-${position.position}-${index}`}
          />
          <span style={{ maxWidth: "180px" }}>
            {position.position} ({position.openings})
          </span>
        </div>
      ),

      onClick: () => onPositionClick(position.position),
    })
  );

  return (
    <div className="listing_page_filter_menu">
      <Divider className="listing_page_filter_menu_divider" orientation="left" style={{ marginBottom: 12 }}>
        <Typography.Title level={5} style={{ margin: 0 }}>
          Job Positions
        </Typography.Title>
      </Divider>
      <Menu mode="inline" items={items} selectedKeys={filters.position} />
    </div>
  );
};

export default JobPositionFilterMenu;
